import React from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Segmented = ({ value, options, onChange, size = "md", className }) => (
  <div className={clsx("inline-flex items-center p-0.5 rounded-md bg-slate-100 border border-slate-200", className)}>
    {options.map(option => (
      <button
        key={option.value}
        type="button"
        title={option.title}
        onClick={() => onChange(option.value)}
        className={clsx(
          "inline-flex items-center gap-1.5 rounded font-medium whitespace-nowrap transition-colors",
          size === "sm" ? "h-6 px-2 text-[11.5px]" : "h-7 px-2.5 text-[12.5px]",
          value === option.value
            ? "bg-white text-slate-900 ring-1 ring-slate-200"
            : "text-slate-500 hover:text-slate-800",
        )}
      >
        {option.icon && <FontAwesomeIcon icon={option.icon} className="text-[11px] opacity-80" />}
        {option.label}
      </button>
    ))}
  </div>
)

export default Segmented
